<template>
  <div class="m-4">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <h5 class="mb-0">Insurance Company Plans</h5>
      <b-button
        class="pt-2 pb-2"
        size="sm"
        @click="addInsuranceCompanyPlan"
        variant="primary"
        >New</b-button
      >
    </div>
    <grid
      :groupFeature="false"
      :columns="columns"
      :autoHeight="true"
      :data="items"
      :columnLines="false"
    ></grid>
    <insurance-company-plan-modal
      v-if="showInsuranceCompanyModal"
      v-model="showInsuranceCompanyModal"
      :formId="planId"
      @onModify="getInsuranceCompanyPlans"
    />
  </div>
</template>

<script>
import Grid from "../../third_party/grid/Grid.vue";
import insuranceCompanyPlanServer from "../../server/insuranceCompanyPlan";
import InsuranceCompanyPlanModal from "./InsuranceCompanyPlanModal.vue";
import { mapActions } from "vuex";

export default {
  name: "InsuranceCompanyCrud",
  components: {
    Grid,
    InsuranceCompanyPlanModal
  },
  data() {
    return {
      list: [],
      planId: null,
      showInsuranceCompanyModal: false
    };
  },
  async mounted() {
    await this.getInsuranceCompanyPlans();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    async getInsuranceCompanyPlans() {
      this.list = await insuranceCompanyPlanServer.query();
    },
    addInsuranceCompanyPlan() {
      this.planId = null;
      this.showInsuranceCompanyModal = true;
    }
  },
  computed: {
    items() {
      return this.list.map(item => ({
        ...item
      }));
    },
    columns() {
      let columns = [
        {
          text: "Name",
          field: "name",
          flex: 1,
          editor: false
        },
        {
          text: "",
          type: "action",
          field: "action",
          cellCls: "pointer-cell",
          align: "right",
          width: 110,
          actions: [
            {
              tooltip: "Edit",
              renderer: () =>
                `<img class="b-action-item" src="${
                  this.isStandalone()
                    ? `/icons/edit.svg`
                    : `/desktop/icons/edit.svg`
                }">`,
              onClick: async ({ record }) => {
                this.planId = record.id;
                this.showInsuranceCompanyModal = true;
              }
            },
            {
              tooltip: "Delete",
              renderer: () =>
                `<img class="b-action-item ml-2 mr-1" src="${
                  this.isStandalone()
                    ? `/icons/delete.svg`
                    : `/desktop/icons/delete.svg`
                }">`,
              onClick: ({ record }) => {
                this.$dialog
                  .confirm(
                    {
                      title: "Are you sure you want to delete this record?"
                    },
                    {
                      view: "confirm-delete"
                    }
                  )
                  .then(async () => {
                    await insuranceCompanyPlanServer.delete(record.id);
                    this.getInsuranceCompanyPlans();
                    this.showAlertSuccess();
                  })
                  .catch(function() {});
              }
            }
          ]
        }
      ];
      return columns;
    }
  }
};
</script>

<style scoped>
.section-title {
  margin-top: 25px;
  margin-bottom: 15px;
}
.section-body {
  min-height: 70px;
}
</style>
